import { render, staticRenderFns } from "./HomePageFeatureBlackstar.vue?vue&type=template&id=af9b2374&scoped=true&"
import script from "./HomePageFeatureBlackstar.vue?vue&type=script&lang=js&"
export * from "./HomePageFeatureBlackstar.vue?vue&type=script&lang=js&"
import style0 from "./HomePageFeatureBlackstar.vue?vue&type=style&index=0&id=af9b2374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9b2374",
  null
  
)

export default component.exports